import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
function SitesGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="break-inside-avoid mb-8">
            <div className="rounded-2xl bg-muted/20 animate-pulse h-[300px] w-full mb-6" />
            <div className="space-y-3">
              <div className="h-8 w-3/4 bg-muted/20 animate-pulse rounded" />
              <div className="h-4 w-full bg-muted/20 animate-pulse rounded" />
              <div className="h-4 w-2/3 bg-muted/20 animate-pulse rounded" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="flex flex-col items-center justify-center py-20 text-muted-foreground">
        <p>Failed to load sites.</p>
      </div>;
  }
  if (!posts.length) {
    return <div className="flex flex-col items-center justify-center py-20 text-muted-foreground">
        <p>No sites found.</p>
      </div>;
  }
  return <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
      {posts.map((post, i) => <div key={post.id} data-index={i} className="break-inside-avoid mb-8">
          <Link to={post.link || "#"} className="group block h-full">
            <Card className="border-none shadow-none bg-transparent rounded-none h-full">
              {/* Image Container */}
              <div className="relative w-full overflow-hidden rounded-2xl shadow-md mb-6 bg-muted">
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-auto object-cover transition-transform duration-[400ms] ease-in-out group-hover:scale-105" /> : <div className="w-full aspect-[4/3] bg-muted flex items-center justify-center text-muted-foreground">
                    <span className="text-sm">No Image</span>
                  </div>}
              </div>

              {/* Content */}
              <CardContent className="p-0 flex flex-col gap-3">
                <h3 className="font-serif font-bold text-2xl text-primary leading-tight">
                  {post.title}
                </h3>
                
                <div className="font-sans text-base text-muted-foreground line-clamp-3" dangerouslySetInnerHTML={{
              __html: post.excerpt || ""
            }} />

                <div className="pt-2">
                  <Button asChild variant="link" className="p-0 h-auto text-[color:var(--ring)] uppercase tracking-[0.15em] font-bold hover:text-[color:var(--ring)]/80 hover:no-underline justify-start">
                    <span>View Details</span>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Link>
        </div>)}
    </div>;
}
export default function SitesGrid() {
  const query = new WP_Query({
    post_type: "post",
    per_page: 9,
    orderby: "date",
    order: "DESC"
  });
  return <section id="sites-grid" className="bg-background py-24">
      <div className="container mx-auto px-4 max-w-[1280px]">
        <PostsProvider wp_query={query}>
          <SitesGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}